import { render, staticRenderFns } from "./BellQr.vue?vue&type=template&id=01a3468d&scoped=true"
import script from "./BellQr.vue?vue&type=script&lang=js"
export * from "./BellQr.vue?vue&type=script&lang=js"
import style0 from "./BellQr.vue?vue&type=style&index=0&id=01a3468d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a3468d",
  null
  
)

export default component.exports